import { useEffect, useState } from 'react';
import ScreenRestriction from './ScreenRestriction';
import { getScreenRestriction } from './screen-restrictions';

function RestrictedRoute({ screenKey, children }) {
  const [loading, setLoading] = useState(true);
  const [restriction, setRestriction] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadRestriction = async () => {
      const data = await getScreenRestriction(screenKey);
      if (isMounted) {
        setRestriction(data);
        setLoading(false);
      }
    };

    loadRestriction();

    return () => {
      isMounted = false;
    };
  }, [screenKey]);

  if (loading) return null;

  if (restriction) {
    return (
      <ScreenRestriction
        title={restriction?.title}
        description={restriction?.description}
        imageUrl={restriction?.image_url}
      />
    );
  }

  return children;
}

export default RestrictedRoute;
